import styled from 'styled-components';
import __ from '../utils/translator';

const outletOnlyLabelStyle = {
  padding: '.25rem .5rem',
  backgroundColor: '#000',
  color: '#fff',
  fontSize: '.625rem',
  textTransform: 'uppercase',
};

export default styled.div`
  position: absolute;
  top: 0;
  right: 0;
  ${outletOnlyLabelStyle};

  &:after {
    content: "${__('Outlet only')}";
  }
`;
